import { useEffect, useState } from "react";
import TextAreaAHSF from "../../../Components/TextAreaAHSF/index";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { GetRecommendationByActionId } from "../../../Redux/Reducers/Manager/Dropdowns/RecommendationByActionId";
import AttachmentASFH from "../../../Components/AttachmentsAHSF";
const ActionOnApplication = (props) => {
  const state = useSelector((state) => {
    return {
      RecommendationByAction:
        state.RecommendationByActionId?.DropDownRecommendationByActionId,
    };
  });
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      GetRecommendationByActionId({
        actionId: "5645b0bd-6368-46ba-817d-22a9c8a6e1cf",
      })
    );
  }, [props.actionGuid]);
console.log(props.FlowActionSpecificRow,"aaaaaaaaaadwdwd");

  return (
    <>

    <>
       <div className="form-grid">
      {props.Recommendation&&state.RecommendationByAction ? (
        <>
          <div className="FirstChild">
            <AllDropDownsAHSF
              fieldsName="Recommendation"
              show={true}
              disabled={props.disabled}
              defaultValue={props.RecommendationIdData}
              arrayOoptionList={state.RecommendationByAction}
              KeyText={"recommendationName"}
              KeyValue={"recommendationId"}
              dropdownType={"normal"}
              onChange={(e) => {
                props.setRecommendationId(e.target.value);
              }}
            />
          </div>
        </>
      ) : (
        <></>
      )}
      {props.Reason ? (
        <>
          <div className="SecondChild">
            <TextAreaAHSF
              fieldsName="Reason"
              show={true}
              disabled={props.disabled}
              onChange={(e) => {
                props.setActionReason(e.target.value);
              }}
              defaultValue={props.ReasonValue}
              showValidationMessage={false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </div>
        </>
      ) : (
        <></>
      )}
      {props.AdditionalNotes ? (
        <>
          <div className="ThreeChild">
            <TextAreaAHSF
              fieldsName="AdditionalNotes"
              show={true}
              disabled={props.disabled}
              onChange={(e) => {
                props.setAdditionalNotes(e.target.value);
              }}
              defaultValue={props.AdditionalNotesData}
              showValidationMessage={false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </div>
        </>
      ) : (
        <></>
      )}

       {props.EditNote ? (
        <>
          <div className="ThreeChild">
            <TextAreaAHSF
              fieldsName="EditNotes"
              show={true}
              disabled={props.disabled}
              onChange={(e) => {
                props.setEditNotes(e.target.value);
              }}
              defaultValue={props.EditNoteData}
              showValidationMessage={false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </div>
        </>
      ) : (
        <></>
      )}
      {props.Attachment ? (
        <>
        <div>
            
        </div>

          <div style={{ marginTop: "45px" }}>
            <AttachmentASFH
              id={"CVDocumentAttachment"}
              textEdit={"انقر لتعديل مرفق محضر الاجتماع"}
              text={"مرفق محضر الاجتماع"}
              title={"إضافة "}
              // show={true}
              // show={true}
              disabled={props.disabled}
              show={!props.disabled}
              clear={false}
              
              AttachementType="ActionAttachment"
              singleFile={props?.CVDocumentAttachment}
              readOnly={false}
              onChange={(e) => {
                props.setAttachment(e.target.files[0]);
              }}
              showValidationMessage={false}
              validationMessage="يرجى تعبئة هذا الحقل"
            />
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
      
      </>:<></>

   
    </>
    
  );
};

export default ActionOnApplication;
